// extracted by mini-css-extract-plugin
export default {"canvas":"eye-contactasino_canvas__BCaAY","video":"eye-contactasino_video__yEZRR"};